import { AxiosResponse } from 'axios';
import { getNameTypeEvent } from 'civil-status/utils/get-name-type-event';
import { DateTime } from 'luxon';
import { NotificaResponse } from 'notifications-from-civil-status/model/notifica';
import { NotificationsList } from 'notifications-from-civil-status/view-models/notifications-list';
import { HttpResponse, PaginationInformation } from 'shell/models/http-response';

export const transformerNotificaList = (
  response: AxiosResponse<HttpResponse<Array<NotificaResponse>>>
): Array<NotificationsList> => {
  const dataRes = response.data.payload || [];
  const datiPaginazione = (response.data.pageInfo || {}) as PaginationInformation;

  return dataRes.map((item) => ({
    totalCount: datiPaginazione?.totalCount || 0,
    idNotifica: item.key?.idAggiornamentoAnagrafe,
    code: `${item.cdComunicazione || ''} ${item.descrizioneCdComunicazione || ''}`,
    dateEffective: item.dataDecorrenzaAnagrafica
      ? DateTime.fromISO(item.dataDecorrenzaAnagrafica).toFormat('dd/MM/yyyy')
      : '',
    dateFormation: item.dataFormazioneAtto
      ? DateTime.fromISO(item.dataFormazioneAtto).toFormat('dd/MM/yyyy')
      : '',
    dateInsert: item.timestampInserimento
      ? DateTime.fromISO(item.timestampInserimento).toFormat('dd/MM/yyyy')
      : '',
    idAnsc: item.idAnscAtto || '',
    owners: item.descIntestatario || '',
    scope: item.cdAmbito || '',
    municipalityFormation: item.descrizioneCdMittente || '',
    state: item.cdStatoAggiornamento || '',
    typeEvent: getNameTypeEvent(item.tipoEvento),
    el: item,
  }));
};
